module.exports = __webpack_public_path__ + "static/img/img-4-12.32698d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-4-12.png
// module id = /LOT
// module chunks = 0